import React from 'react';
import PropTypes from 'prop-types';
import {
    DEFAULT_MEASURE_AGGREGATION,
    GROUP_BY,
    NUMBER_AGGREGATIONS,
    STRING_AGGREGATIONS,
} from '../../../../../models/pipeline/steps/dataset/aggregations';
import {
    aggregationSelectEvent,
    inputSubmitEvent
} from '../../../../../services/query_builder_events';
import AttributeMenu from '../attribute_menu';
import AggregationList from './aggregation_list';

export default class AggregationSelector extends AttributeMenu {
    constructor(props) {
        super(props);
        const aggregations = (props.column.type === 'string' ? STRING_AGGREGATIONS : NUMBER_AGGREGATIONS).slice();
        if (props.showGroupBy) {
            aggregations.unshift(GROUP_BY);
        }
        const selectedAggregation = DEFAULT_MEASURE_AGGREGATION[props.column.type];
        const selectedAggIndex = aggregations.indexOf(selectedAggregation);
        Object.assign(this.state, {
            aggregations,
            selectedAggIndex,
            selectedAggregation,
        });
    }

    componentDidMount() {
        super.componentDidMount();
        this.unbindInputSubmitEventListener = inputSubmitEvent.listen(() => {
            aggregationSelectEvent.emit(this.state.selectedAggregation, this.props.column);
        });
    }

    componentDidUpdate(prevProps, prevState) {
        super.componentDidUpdate();
        const {searchQuery} = this.state;
        const {column, showGroupBy} = this.props;
        if (prevState.searchQuery !== searchQuery) {
            let aggregations = (column.type === 'string' ? STRING_AGGREGATIONS : NUMBER_AGGREGATIONS).slice();
            if (showGroupBy) {
                aggregations.unshift(GROUP_BY);
            }
            if (searchQuery) {
                aggregations = aggregations.filter(agg => agg.matchesQuery(searchQuery));
            }
            this.setState({aggregations, selectedAggregation: aggregations[0], selecteAggIndex: 0});
        }
    }

    componentWillUnmount() {
        super.componentWillUnmount();
        this.unbindInputSubmitEventListener();
    }

    updateSelectedItem(delta) {
        super.updateSelectedItem(delta);
        let {selectedAggIndex = -1, aggregations} = this.state;
        selectedAggIndex += delta;
        if (selectedAggIndex >= aggregations.length) {
            selectedAggIndex = 0;
        } else if (selectedAggIndex < 0) {
            selectedAggIndex = aggregations.length - 1;
        }
        this.setState({selectedAggIndex, selectedAggregation: aggregations[selectedAggIndex]});
    }

    renderMenu() {
        const {column} = this.props;
        const {selectedAggregation, aggregations} = this.state;
        return (
            <div className="agg-panel">
                <AggregationList
                    aggregations={aggregations}
                    column={column}
                    selectedAggregation={selectedAggregation}
                    onHover={(agg) => { this.setState({selectedAggregation: agg}); }}
                    onLeave={() => { this.setState({selectedAggregation: null}); }}
                />
            </div>
        );
    }
}

AggregationSelector.propTypes = Object.assign(
    {
        showGroupBy: PropTypes.bool,
    },
    AttributeMenu.propTypes,
);

AggregationSelector.defaultProps = Object.assign(
    {
        showGroupBy: false,
    },
    AttributeMenu.defaultProps,
);
